module.exports = __webpack_public_path__ + "img/semi_truck_h.e849d985.png";